import { ActionReducerMap } from '@ngrx/store';
import * as reducers from './reducers';

export interface AppState {
  [x: string]: any;
  jobs: reducers.JobPositionsState;
  apps: reducers.ApplicationsState;
  auth: reducers.authState;
  lm: reducers.lmRecordState;
  ls: reducers.SannaState;
}

export const appReducers: ActionReducerMap<AppState> = {
  jobs: reducers.jobPositionsReducer,
  apps: reducers.ApplicationsReducer,
  auth: reducers.AuthReducer,
  lm: reducers.LmRecordsReducer,
  ls: reducers.SannaReducer, // ls: Licencia SANNA
};
// TODO: comentar
